// src/AirtableList.js
import React, { useEffect, useState } from "react";
import "./skeleton.css";

const ToolSkeleton = () => (
  <div className="tools-grid">
    {[1, 2, 3, 4, 5, 6].map((index) => (
      <div key={index} className="tool-card skeleton-wrapper">
        <div className="skeleton-tool">
          <div className="skeleton-image"></div>
          <div style={{ flex: 1 }}>
            <div className="skeleton-text" style={{ width: "50%", marginBottom: 6 }}></div>
            <div className="skeleton-text" style={{ width: "80%", height: 12 }}></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

const AIRTABLE_API_KEY = process.env.REACT_APP_AIRTABLE_API_KEY;
const AIRTABLE_BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;

const AirtableList = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const response = await fetch(
          `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/Tools`,
          {
            headers: {
              Authorization: `Bearer ${AIRTABLE_API_KEY}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch records");
        }
        const data = await response.json();
        setRecords(data.records);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching records:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchRecords();
  }, []);

  if (loading) return <ToolSkeleton />;
  if (error) return <div className="error-message">Error: {error}</div>;

  return (
    <div className="tools-grid">
      {records.map((record) => (
        <div key={record.id} className="tool-card">
          {record.fields.Logo_url && (
            <img
              className="tool-card-logo"
              src={record.fields.Logo_url}
              alt={record.fields.Name}
            />
          )}
          <div>
            <h3>{record.fields.Name}</h3>
            {record.fields.Description && <p>{record.fields.Description}</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AirtableList;
